import http from '@services/http';
export default {
  getAllCompanies() {
    return http.get('Companies/GetAllCompanies', {});
  },

  getMetaData() {
    return http.get('Metadata/GetMetaData', {});
  }

};